import {createElement, FC, memo} from 'react';
import {isObject, isFunction} from 'lodash';
import {ElementMap} from './types';
import {useElementMap} from './ElementMapProvider';

interface FormElementProps {
  type: keyof ElementMap,
  props: any,
}

const FormElement: FC<FormElementProps> = ({type, props}) => {
  const elementMap = useElementMap();
  const {children, ...otherProps} = props;

  if (!type) return null;

  if (elementMap[type]) {
    return createElement(elementMap[type], otherProps, children);
  }

  if (!children) {
    console.warn(`${type} not found in given elementMap: {${
      Object.keys(elementMap).join(', ')
    }}. Nothing is rendered.`)
    return null;
  }

  console.warn(`${type} not found in given elementMap: {${
    Object.keys(elementMap).join(', ')
  }}`)

  return createElement('div', null, children);
};

const MemoizedFormElement = memo(
  FormElement,
  (prevProps, nextProps) =>
    isObject(prevProps.props) === isObject(nextProps.props)
    && prevProps.props.visible === nextProps.props.visible
    && isFunction(prevProps.props.onDelete) === isFunction(nextProps.props.onDelete)
    && prevProps.type === nextProps.type
    && prevProps.props.options === nextProps.props.options
    && prevProps.props.isLastElement === nextProps.props.isLastElement
    && prevProps.props.index === nextProps.props.index
    && prevProps.props.totalIndexes === nextProps.props.totalIndexes
);

export default MemoizedFormElement;
